import { BankAccount } from "../../../../MPP-Common-SPA/utils/generator/applicationModels";

export const bankAccounts: Record<string, BankAccount> = {
  "Auto Deposit": {
    institutionNumber: "003",
    transitNumber: "00001",
    accountNumber: "5006100",
    bankName: "Bank of Montreal",
  },
  "Non-Auto Deposit": {
    institutionNumber: "003",
    transitNumber: "10000",
    accountNumber: "1234567",
    bankName: "Bank of Montreal",
  },
};

export const bankAccountFields = [
  "institutionNumber",
  "transitNumber",
  "bankAccount",
  "confirmBankAccount",
  "bankName",
];
